import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import HeroSection from "@/views/sections/HeroSection.vue"
import SkillsSection from "@/views/sections/SkillsSection.vue"
import ProjectsSection from "@/views/sections/ProjectsSection.vue"
import TestimonialsSection from "@/views/sections/TestimonialsSection.vue"
import ServicesSection from "@/views/sections/ServicesSection.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeroSection),
    _createVNode(SkillsSection),
    _createVNode(ProjectsSection),
    _createVNode(TestimonialsSection),
    _createVNode(ServicesSection)
  ]))
}
}

})